import { HeaderSpanMainDiv } from "../../../../../styles/reusable/headerspanstyles";

interface headerSpanProp {
  text: string;
}
const HeaderSpan = ({ text }: headerSpanProp) => {
  return (
    <HeaderSpanMainDiv>
      <div className="block-header">
        <div className="block-header-radial-gradient">
          <div className="block-header-text-wrapper">
            <p>{text} </p>
          </div>
        </div>
      </div>
    </HeaderSpanMainDiv>
  );
};

export default HeaderSpan;
